import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { DirectivesModule } from '@mmx/shared'

import { ButtonGroupComponent } from './button-group.component'

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
  ],
  declarations: [
    ButtonGroupComponent,
  ],
  exports: [
    ButtonGroupComponent,
  ],
})
export class ButtonGroupModule {}
